import { SvgIcon, SvgIconProps } from '@mui/material';

export default function CadFileIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props} viewBox="0 0 64 64">
      {/* File outline */}
      <path
        d="M 10 4 C 7.791 4 6 5.791 6 8 L 6 56 C 6 58.209 7.791 60 10 60 L 54 60 C 56.209 60 58 58.209 58 56 L 58 18 L 44 18 C 41.791 18 40 16.209 40 14 L 40 4 L 10 4 z"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      {/* Folded corner */}
      <path
        d="M 40 4 L 40 14 C 40 16.209 41.791 18 44 18 L 58 18 L 40 4 z"
        fill="currentColor"
        opacity="0.2"
      />
      {/* CAD label background */}
      <rect
        x="12"
        y="30"
        width="40"
        height="16"
        rx="8"
        ry="8"
        fill="currentColor"
      />
      {/* CAD text */}
      <text
        x="32"
        y="41"
        fontSize="10"
        fontWeight="bold"
        textAnchor="middle"
        fill="white"
        fontFamily="Arial, sans-serif"
      >
        CAD
      </text>
    </SvgIcon>
  );
}
